import { FormGroup } from '@angular/forms';
import { STOP_TYPE } from 'src/app/core/enums/operations.enum';
import { TrackingNumberSearch } from 'src/app/core/models/operations';
import {
  CreateDeliveryRequest,
  CreateDeliveryResponse,
  DeliveryPackage,
  ServiceLevelCodsResponse,
  ValidateDeliveryPackageResponse,
} from 'src/app/core/models/operations/operations-delivery.model';
import {
  CreatePickupRequest,
  CreatePickupResponse,
  DeletePackageResponse,
} from 'src/app/core/models/operations/operations-pickup-stop.model';

export const ADD_STOP_CONSTANTS = {
  ADD_STOP: $localize`Add Pickup`.toUpperCase(),
  ADD_DELIVERY: $localize`Add Delivery`.toUpperCase(),
  ADD_PACKAGES: $localize`Add Package(s)`.toUpperCase(),
  PICKUP: $localize`Pickup`,
  SHIPPER_PLACEHOLDER: $localize`Enter 6 alphanumeric characters`,
  BACK: $localize`Back`,
  COMPLETE_STOP: $localize`Completed`,
  PLANNED_STOP: $localize`Planned`,
  INFO_NOTICE: $localize`Info Notice`,
  NO_PKG_STATUS: $localize`No Pkg. Pickup Status`,
  COMPLETE_TIME_PLACEHOLDER: '00:00',
  COMPLETE_TIME: $localize`Complete Time`,
  PICKUP_REQUEST_NUMBER: $localize`Pickup Request #`,
  SAVE_TO_ADDRESS_BOOK: $localize`Save to address book`,
  SEARCH_ADDRESS_BOOK: $localize`Search Address Book`,
};

export const MOCK_CREATE_DELIVERY_REQUEST: CreateDeliveryRequest = {
  stop: {
    address: {
      city: 'CHARLOTTETOWN',
      consignee: 'COD USER 1',
      country: 'CA',
      postalCode: 'C1A4N9',
      state: 'PE',
      streetParsed: {
        name: '435 UNIVERSITY AVE',
      },
    },
    stopType: STOP_TYPE.DELIVERY,
    completed: false,
    density: 'RESIDENTIAL',
    loop: '001',
    planDate: new Date('01/01/2014'),
    planSequence: 1,
    userId: 'Vijaya',
    stopId: 1,
  },

  deliveryPackages: [
    {
      shipperAccount: '127122',
      trackingNumber: '1Z1271220312345683',
      position: 0,
    },
    {
      shipperAccount: '127123',
      trackingNumber: '1Z1271220312345683',
      position: 1,
    },
  ],
};

export const MOCK_CREATE_PICKUP_REQUEST: CreatePickupRequest = {
  stop: {
    address: {
      city: 'CHARLOTTETOWN',
      consignee: 'COD USER 1',
      country: 'CA',
      postalCode: 'C1A4N9',
      state: 'PE',
      streetParsed: {
        name: '435 UNIVERSITY AVE',
      },
    },
    stopType: STOP_TYPE.PICKUP,
    completed: false,
    density: 'RESIDENTIAL',
    loop: '001',
    planDate: new Date('01/01/2014'),
    planSequence: 1,
    userId: 'Vijaya',
    stopId: 1,
  },

  pickupPackages: [
    {
      shipperAccount: '127122',
      trackingNumber: '1Z1271220312345683',
      position: 0,
    },
    {
      shipperAccount: '127123',
      trackingNumber: '1Z1271220312345684',
      position: 1,
    },
  ],
};

export const LABELS = {
  STOP_TYPE: $localize`Stop Type`,
  CONSIGNEE: $localize`Consignee`,
  STREET_ADDRESS: $localize`Street Address`,
  NUMBER: $localize`Number`,
  ADDRESS_2: $localize`Address 2`,
  FLOOR: $localize`Floor`,
  SUITE: $localize`Suite`,
  CITY: $localize`City`,
  ROUTE: $localize`Route`,
  STATE: $localize`State / Province`,
  POSTAL_CODE: $localize`Postal Code`,
  COUNTRY: $localize`Country`,
  LATITUDE: $localize`Latitude`,
  LONGITUDE: $localize`Longitude`,
  PLAN_DATE: $localize`Plan Date`,
  ADD: $localize`Add`,
  ADD_PACKAGE: $localize`Add a Package`,
  INFO_NOTICE: $localize`Info Notice`,
};

export const CREATE_PICKUP_STOP: CreatePickupRequest = {
  stop: {
    loop: 'QA1',
    stopId: 0,
    userId: 'TESTA',
    slicOverride: '0',
    planDate: new Date(),
    planSequence: 3,
    completed: true,
    density: 'COMMERCIAL',
    address: {
      address1: '',
      address2: '',
      address3: '',
      city: 'CHARLOTTETOWN',
      consignee: 'SCHEDTEST1',
      country: 'CA',
      floor: '',
      addressLatitude: '1.234',
      addressLongitude: '2,543',
      postalCode: 'A1B2C3',
      state: 'PE',
      suite: '',
      updateTimeStamp: '2024-01-10T12:12:52Z',
      streetParsed: {
        name: 'MOUNTAIN RD',
        number: '32',
        prefix: '',
        suffix: '',
        type: 'null',
      },
    },
    stopTime: '2024-01-10T13:21:55Z',
    stopStartTime: '2024-01-10T17:36:55Z',
    latitude: 2.3,
    longitude: 2.3,
  },
  pickupDetail: {
    pickupType: 'ONROAD',
    pickupRequestNumber: 'TBD234',
    scanCode: '12',
  },
  pickupPackages: [
    {
      trackingNumber: '1Z1271220209224786',
      shipperAccount: '127122',
      paymentDue: {
        amount: '30.0',
        currency: 'USD',
      },
      payment: {
        amount: '30.0',
        currency: 'USD',
        type: 'CASH',
      },
      scanCode: 'KS',
      remark: 'PICKED UP',
      position: 0,
    },
  ],
};

export const CREATE_DELIVERY_REQUEST: CreateDeliveryRequest = {
  stop: {
    address: {
      city: 'CHARLOTTETOWN',
      consignee: 'COD USER 1',
      country: 'CA',
      postalCode: 'C1A4N9',
      state: 'PE',
      streetParsed: {
        name: '435 UNIVERSITY AVE',
      },
    },
    completed: false,
    density: 'RESIDENTIAL',
    loop: '001',
    planDate: new Date(),
    planSequence: 1,
    userId: 'Vijaya',
  },
  deliveryPackages: [
    {
      shipperAccount: '127122',
      trackingNumber: '1Z1271220312345683',
      position: 0,
    },
  ],
};

export const CREATE_PICKUP_RESPONSE: CreatePickupResponse = {
  code: 200,
  status: 'success',
  message: 'Stop processed',
  deviceStatus: 'Active',
  response: {
    summary: {
      txId: '179c8e6a-3a82-4b8d-83ae-f77777b19234',
      received: 1,
      accepted: 1,
      rejected: 0,
    },
    stopId: 1168488854,
  },
};

export const CREATE_DELIVERY_RESPONSE: CreateDeliveryResponse = {
  code: 200,
  status: 'success',
  message: 'Stop processed',
  deviceStatus: 'Active',
  response: {
    summary: {
      txId: '179c8e6a-3a82-4b8d-83ae-f77777b19234',
      received: 1,
      accepted: 1,
      rejected: 0,
    },
    stopId: 1168488854,
  },
};

export const DELETE_DELIVERY_RESPONSE: DeletePackageResponse = {
  code: 0,
  status: 'success',
  message: 'successfully deleted delivery package',
  deviceStatus: '',
  response: {
    summary: {
      txId: '',
      received: 0,
      accepted: 0,
      rejected: 0,
    },
    stopId: 0,
  },
};

export const SERVICE_LEVEL_CODS_RESPONSE: ServiceLevelCodsResponse = {
  code: 200,
  status: 'success',
  response: {
    serviceLevels: [{ code: 'STANDARD' }, { code: 'EXPRESS' }],
  },
};

export const VALIDATE_DELIVERY_PACKAGE_RESPONSE: ValidateDeliveryPackageResponse =
  {
    code: 0,
    status: '',
    message: '',
  };

export type PackagesType = {
  trackingNumber: string;
  shipperAccount: string;
  paymentDue?: {
    amount: number;
  };
  declaredValue?: {
    amount: number;
  };
  position: number;
};

export type AddStopRequest = {
  stop: {
    loop: string;
    userId: string;
    planSequence: number;
    planDate: Date;
    density: string;
    completed: boolean;
    stopType: STOP_TYPE;
    address: {
      id?: number;
      consignee: string;
      country: string;
      postalCode: string;
      state: string;
      city: string;
      address1: string;
      floor: string;
      suite: string;
      streetParsed: {
        name: string;
        number?: string;
        prefix?: string;
        suffix?: string;
        type?: string;
      };
    };
  };
  pickupDetail?: {
    accessPointId?: string;
    pickupRequestNumber: string;
    pickupType: string;
    scanCode: string;
    infoNotice?: string;
  };
  deliveryPackages?: DeliveryPackage[];
  pickupPackages?: DeliveryPackage[];
};

export enum POPUP_TYPE {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
}

export enum STOP_TIME_TYPE {
  PLANNED,
  COMPLETE,
}

export interface AddOperationsStopData {
  route: string;
  planDate: Date;
  trackingNumData: TrackingNumberSearch | null;
  type: POPUP_TYPE;
  form: FormGroup;
}

export interface AddOperationsReturnData {
  request: CreateDeliveryRequest | CreatePickupRequest;
  planned: STOP_TIME_TYPE;
  back: boolean;
}
